import {useState} from 'react';
import {Redirect} from 'react-router-dom';
import {connect, useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import {Grid} from 'semantic-ui-react';
import {useToasts} from 'react-toast-notifications';
import MainLayout from '../layouts/main';
import MobileForm from './mobile-form';
import SMSKeyForm from '../shared/sms-key-form';
import PasswordForm from './password-form';
import ErrorMessage from '../shared/error-message';
import {checkSMSKeyRequest, forgetPasswordRequest, resetPasswordRequest} from '../../redux/actions/user';
import {loginUser} from '../../redux/actions/auth';
import {AUTHENTICATED} from '../../redux/constants';

function ForgetPasswordPage(props) {
  const [step, setStep] = useState(0);
  const [mobile, setMobile] = useState(null);
  const [uid, setUID] = useState(null);
  const [token, setToken] = useState(null);
  const [error, setError] = useState(null);

  const {addToast} = useToasts();
  const isAuthenticated = useSelector(state => state.auth.status === AUTHENTICATED);
  if (isAuthenticated) return (<Redirect to='/reports'/>);

  function renderForm(step) {
    if (step === MOBILE)
      return (
        <MobileForm
          onSubmit={async function (mobile) {
            const {payload: {uid}} = await props.forgetPasswordRequest(mobile);
            setMobile(mobile);
            setUID(uid);
            setStep(SMS_KEY);
          }}
          onError={setError}
        />
      );

    if (step === SMS_KEY)
      return (
        <SMSKeyForm
          back
          mobile={mobile}
          onSubmit={async function (smsKey) {
            const {payload: {token}} = await props.checkSMSKeyRequest(uid, smsKey);
            setToken(token);
            setStep(PASSWORD);
          }}
          onResend={async function () {
            const {payload: {uid}} = await props.forgetPasswordRequest(mobile);
            setUID(uid);
          }}
          onBack={setStep.bind(null, MOBILE)}
          onError={setError}
        />
      );

    if (step === PASSWORD)
      return (
        <PasswordForm
          onSubmit={async function (password) {
            await props.resetPasswordRequest(uid, token, password);
            addToast('رمز عبور شما با موفقیت تغییر کرد.', {appearance: 'success'});
            await props.loginUser({mobile, password});
            setStep(MOBILE);
          }}
        />
      );

    return null;
  }

  return (
    <MainLayout loginRequired={false} consultPackageRequired={false} packageRequired={false}>
      {error ? (
        <ErrorMessage message={error}/>
      ) : (
        <Grid centered verticalAlign='middle' size='big'>
          <Grid.Column mobile={12} tablet={10} computer={8}>
            {renderForm(step)}
          </Grid.Column>
        </Grid>
      )}
    </MainLayout>
  );
}

const [MOBILE, SMS_KEY, PASSWORD] = [0, 1, 2];

ForgetPasswordPage.propTypes = {
  checkSMSKeyRequest: PropTypes.func.isRequired,
  forgetPasswordRequest: PropTypes.func.isRequired,
  resetPasswordRequest: PropTypes.func.isRequired,
};

export default connect(
  null,
  {checkSMSKeyRequest, forgetPasswordRequest, resetPasswordRequest, loginUser}
)(ForgetPasswordPage);
